module.exports = __webpack_public_path__ + "static/media/platform_2.c28936ee.svg";